import { Cancel, CheckCircle, CloudOff, Sync } from '@mui/icons-material';
import type { SxProps, Theme } from '@mui/material';

export type ResultIconProps = {
  variant?: 'success' | 'warning' | 'success-warning' | 'offline' | 'uploading';
  size?: 'large' | 'medium' | 'small';
  sx?: SxProps<Theme>;
};

export const ResultIcon = ({ variant = 'success', size = 'large', sx }: ResultIconProps) => {
  switch (variant) {
    case 'success':
      return (
        <CheckCircle
          fontSize={size}
          data-testid="accepted-icon"
          sx={{
            backdropFilter: 'blur(3px)',
            backgroundColor: 'white',
            borderRadius: '100%',
            color: (theme) => theme.palette.success.dark,
            ...(sx || {}),
          }}
        />
      );
    case 'warning':
      return (
        <Cancel
          fontSize={size}
          data-testid="rejected-icon"
          sx={{
            backdropFilter: 'blur(3px)',
            backgroundColor: 'white',
            borderRadius: '100%',
            color: (theme) => theme.palette.warning.main,
            ...(sx || {}),
          }}
        />
      );
    case 'success-warning':
      return (
        <CheckCircle
          fontSize={size}
          data-testid="success-warning-icon"
          sx={{
            backdropFilter: 'blur(3px)',
            backgroundColor: 'white',
            borderRadius: '100%',
            color: (theme) => theme.palette.success.dark,
            ...(sx || {}),
          }}
        />
      );
    case 'offline':
      return (
        <CloudOff
          fontSize={size}
          data-testid="offline-icon"
          sx={{
            backdropFilter: 'blur(3px)',
            backgroundColor: 'white',
            borderRadius: '100%',
            color: (theme) => theme.palette.text.secondary,
            ...(sx || {}),
          }}
        />
      );
    case 'uploading':
      return (
        <Sync
          fontSize={size}
          data-testid="uploading-icon"
          sx={{
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
            animation: 'spin 2s linear infinite',
            animationDirection: 'reverse',
            backdropFilter: 'blur(3px)',
            backgroundColor: 'white',
            borderRadius: '100%',
            color: (theme) => theme.palette.primary.main,
            ...(sx || {}),
          }}
        />
      );
  }
};
